import React from 'react';

export default function SectionHeader({ tag, title, subtitle, light = false, center = false }) {
  return (
    <div style={{ textAlign: center ? 'center' : 'left' }}>
      {tag && (
        <span style={{
          fontFamily: '"Barlow Condensed"', fontSize: '0.8rem', fontWeight: 700,
          letterSpacing: '0.15em', textTransform: 'uppercase',
          color: 'var(--orange)', display: 'block', marginBottom: '0.5rem',
        }}>{tag}</span>
      )}
      <h2 style={{
        fontFamily: '"Bebas Neue"',
        fontSize: 'clamp(2.2rem, 4vw, 3.2rem)',
        color: light ? 'white' : 'var(--navy)',
        letterSpacing: '0.03em', lineHeight: 1,
        marginBottom: subtitle ? '0.75rem' : 0,
      }}>{title}</h2>
      {subtitle && (
        <p style={{
          fontSize: '1rem', fontWeight: 400,
          color: light ? 'var(--silver)' : 'var(--text-mid)',
          lineHeight: 1.6,
          maxWidth: center ? 560 : 'none',
          margin: center ? '0 auto' : 0,
        }}>{subtitle}</p>
      )}
    </div>
  );
}
